<template>
    <div class="wrapper vh-100">
        <div class="container-fluid h-100 px-0">
             <router-link to="/" exact
                class="text-decoration-none logo__link" >
                <img
                src="@/assets/images/logo-white.svg"
                alt="logo"
                class="img-fluid"
                >
                <span class="visually-hidden">Icon-only</span>
             </router-link>
            <TheSideBar/>
            <TheHeader></TheHeader>
             <main class="">
                <div class="main-content">
                    <div class="container-fluid">
                      <router-view v-slot="{ Component }">
                        <transition name="fade" mode="out-in">
                          <component :is="Component" />
                        </transition>
                      </router-view>

                        <!-- <transition name="fade" mode="out-in">
                             <router-view :key="$route.path"></router-view>
                        </transition> -->
                    </div>
                </div>
            </main>
        </div>
     </div>
</template>
<script>
import TheSideBar from '@/components/core/Navigation/TheSideBar'
import TheHeaderLg from '@/components/core/Navigation/Header/TheHeaderLg'
import TheHeaderMd from '@/components/core/Navigation/Header/TheHeaderMd'
import TheHeader from '../Navigation/Header/TheHeader'
import { mapGetters } from 'vuex'
import axios from 'axios'
export default {
  name: 'TheContainer',
  components: {
    TheHeader,
    TheSideBar,
    TheHeaderLg,
    TheHeaderMd
  },
  computed: {
    ...mapGetters({
      user: 'auth/user'
    })
  },
  created(){

    if(Object.keys(this.$route.meta).includes('uri')){
 
    axios.defaults.headers.common['X-URI'] = this.$route.meta.uri;
    } 
  },
  watch:{
    $route:function(to,from){

      

      if(localStorage.getItem('realToken')){

        localStorage.setItem('token',localStorage.getItem('realToken'))

        localStorage.removeItem('realToken')

        }
    }
  }

}
</script>
<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
